import { TZDate, TZDateMini } from '@date-fns/tz';
import { addDays, addMonths, addYears } from 'date-fns';

import { getTimezone } from '@dynatrace-sdk/user-preferences';

import type {
  CalendarReducerAction,
  CalendarState,
} from '../types/shared-types.js';
import { getWeekStartOrEnd } from '../utils/helpers.js';

/** Calendar reducer */
export function reducer(
  state: CalendarState,
  action: CalendarReducerAction,
): CalendarState {
  switch (action.type) {
    case 'activeDateChange':
      return {
        ...state,
        activeDate: action.payload.activeDate,
        currentView: action.payload.changeToView ?? state.currentView,
      };
    case 'currentViewChange':
      return { ...state, currentView: action.payload };
    case 'shouldUpdateFocusFromKeydown':
      return { ...state, shouldUpdateFocusFromKeydown: action.payload };
    case 'navigateCurrentView': {
      let newActiveDate: TZDate;
      const { amount, unit } = action.payload;
      const affectedScale = unit ?? state.currentView;
      const realAmount =
        typeof amount === 'number'
          ? amount
          : getWeekStartOrEnd(amount, state.activeDate);

      const configuredTimezone = getTimezone();
      const activeDate = new TZDateMini(state.activeDate, configuredTimezone);

      switch (affectedScale) {
        case 'day':
          newActiveDate = addDays(activeDate, realAmount);
          break;
        case 'month':
          newActiveDate = addMonths(activeDate, realAmount);
          break;
        case 'year':
          newActiveDate = addYears(activeDate, realAmount);
          break;
      }

      return {
        ...state,
        activeDate: newActiveDate,
      };
    }
    default:
      // Should never happen
      // oxlint-disable-next-line no-console
      console.warn('The dispatched action does not exist.');
      return state;
  }
}
